import { Paper, Typography } from "@material-ui/core"
import SnackContext from "@root/components/Snackbar"
import { RootState } from "@root/store"
import React from "react"
import { useSelector } from "react-redux"
import { useSettingStyles } from "../styles"
import ChannelAttributes from "./ChannelAttributes"
import ChannelCustomEvent from "./ChannelCustomEvent"
import ChannelPreferenceCenters from "./ChannelPreferenceCenters"
import ChannelSubscriptions from "./ChannelSubscriptions"
import ChannelTags from "./ChannelTags"

const Channel: React.FC = () => {
  const classes = useSettingStyles()
  const { error } = useSelector((state: RootState) => state.channel)
  const { createSnack } = React.useContext(SnackContext)

  React.useEffect(() => {
    if (error) {
      createSnack(error)
    }
  }, [error])

  return (
    <>
      <Paper className={classes.paper} data-qa-selector="channel-tags">
        <Typography variant="h4">Tags</Typography>
        <ChannelTags />
      </Paper>
      <Paper className={classes.paper} data-qa-selector="channel-attributes">
        <Typography variant="h4">Attributes</Typography>
        <ChannelAttributes />
      </Paper>
      <Paper className={classes.paper} data-qa-selector="channel-subscriptions">
        <Typography variant="h4">Subscription Lists</Typography>
        <ChannelSubscriptions />
      </Paper>
      <Paper className={classes.paper} data-qa-selector="channel-custom-event">
        <Typography variant="h4">Custom Event</Typography>
        <ChannelCustomEvent />
      </Paper>
      <Paper
        className={classes.paper}
        data-qa-selector="channel-preference-centers"
      >
        <Typography variant="h4">Preference Centers</Typography>
        <ChannelPreferenceCenters />
      </Paper>
    </>
  )
}

export default Channel
